import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import GlyphSearch from '@/assets/icons/glyph_search.svg?component';
import { SvgIcon } from '@/components/atoms/SvgIcon/SvgIcon';
import TextField from '@/components/atoms/TextField';

interface UserSearchFieldProps {
    filter: string;
    setFilter: (filter: string) => void;
}

/** The user table's search, applied a second after typing stops. */
export default function UserSearchField({ filter, setFilter }: UserSearchFieldProps) {
    const { t } = useTranslation();
    const [value, setValue] = useState(filter);

    useEffect(() => {
        const handler = setTimeout(() => {
            setFilter(value);
        }, 1000);

        return () => {
            clearTimeout(handler);
        };
    }, [setFilter, value]);

    return (
        <span>
            <TextField
                suffix={<SvgIcon icon={GlyphSearch} size="custom" customSize={22} />}
                value={value || ''}
                onChange={(e) => setValue(e.target.value)}
                placeholder={t('common.labels.searchText')}
            />
        </span>
    );
}
